import { gql } from '@apollo/client'
import { TASK_FRAGMENT } from './TaskFragment'
import { STORE_ADDRESS_FRAGMENT } from './StoreAddressFragment'
import { ZONE_HIERARCHY_GLOBAL_SEARCH_RESULT_FRAGMENT } from './ZoneHierarchyGlobalSearchResultFragment'

export const STORE_FRAGMENT = gql`
  fragment Store on CompanyStore {
    id
    isActive
    totalAudits
    distance
    physicalStoreId
    storeChain
    name
    internalStoreId
    category
    hasAllFormulas
    image {
      id
      url
    }
    address {
      ...StoreAddress
    }
    point {
      latitude
      longitude
    }
    lastAudit
    daysSinceAudit
    tasks {
      ...Task
    }
    zones {
      ...ZoneHierarchyGlobalSearchResult
    }
  }
  ${TASK_FRAGMENT}
  ${STORE_ADDRESS_FRAGMENT}
  ${ZONE_HIERARCHY_GLOBAL_SEARCH_RESULT_FRAGMENT}
`
